// @tenorlab/nuxt-dashboard-pro
// file: app/models/navigation/catalog.ts
import { menuItemIds } from './menuItemIds'
import type { INavigationItem } from './interfaces'

interface IMenuItemsCatalog {
  //homeMenu: INavigationItem
  aboutMenu: INavigationItem
  anotherPageMenu: INavigationItem
  dashboardsMenu: INavigationItem
  dashboardReadonlyMenu: INavigationItem
}

export const menuItemsCatalog: IMenuItemsCatalog = {
  // homeMenu: {
  //   id: menuItemIds.home,
  //   name: 'Home',
  //   icon: 'HomeIcon',
  //   selected: true,
  //   isExpanded: false,
  //   hidden: false,
  // },

  aboutMenu: {
    id: menuItemIds.about,
    name: 'About',
    href: '/about',
    icon: 'Square',
    selected: false,
    isExpanded: false,
    hidden: false,
    children: [],
    // badgeValue: '32',
    // badgeCategory: 'success',
  },

  anotherPageMenu: {
    id: menuItemIds.anotherpage,
    name: 'Other',
    icon: 'Square',
    selected: false,
    isExpanded: false,
    hidden: false,
    children: [],
    // badgeValue: '32',
    // badgeCategory: 'success',
  },

  dashboardsMenu: {
    id: menuItemIds.dashboards,
    name: 'Dashboards',
    icon: 'LayoutDashboard',
    selected: false,
    isExpanded: false,
    hidden: false,
  },

  dashboardReadonlyMenu: {
    id: menuItemIds.dashboardReadonly,
    name: 'Readonly',
    icon: 'Square',
    selected: false,
    isExpanded: false,
    hidden: false,
  },
}
